import { render, staticRenderFns } from "./TheSpinner.vue?vue&type=template&id=85b1c2de&scoped=true"
import script from "./TheSpinner.vue?vue&type=script&lang=js"
export * from "./TheSpinner.vue?vue&type=script&lang=js"
import style0 from "./TheSpinner.vue?vue&type=style&index=0&id=85b1c2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b1c2de",
  null
  
)

export default component.exports